<template>
    <BasePanel 
        headline="lang_GENERIC_AZ_PANEL_CAPTION_METADATA"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>

            <v-row class="pt-4">
                <!-- 1st column -->
                <v-col cols="3">
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getLanguage"
                            :label="$t('lang_GENERIC_CAPTION_LANGUAGE')"
                            :alvqa="alvqa + '-language'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getFoundingDate"
                            :label="$t('lang_AZ_GROUPS_CAPTION_FOUNDING_DATE')"
                            :alvqa="alvqa + '-founding-date'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getCustomerNumber"
                            :label="$t('lang_GENERIC_AZ_CAPTION_CUSTOMER_NUMBER')"
                            :alvqa="alvqa + '-customer-number'"
                        />
                    </v-row>
                </v-col>

                <!-- 2nd column -->
                <v-col cols="4">
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getLabelCompany"
                            :label="$t('lang_GENERIC_AZ_CAPTION_ASSIGN_TO_LABEL_COMPANY')"
                            :alvqa="alvqa + '-label-company'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getLabelcode"
                            :label="$t('lang_AZ_PERSONS_CAPTION_LABELCODE')"
                            :alvqa="alvqa + '-labelcode'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getTonisNextPrefix"
                            :label="$t('lang_AZ_GROUPS_CAPTION_TONIS_NEXT_PREFIX')"
                            :alvqa="alvqa + '-tonis-next-prefix'"
                        /> 
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getTonisNextSuffix"
                            :label="$t('lang_AZ_GROUPS_CAPTION_TONIS_NEXT_SUFFIX')"
                            :alvqa="alvqa + '-tonis-next-suffix'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getTasFromPricelist" 
                            :label="$t('lang_AZ_GROUPS_CAPTION_TAS_FROM_PRICELIST')"
                            :alvqa="alvqa + '-tas-from-pricelist'"
                        />
                    </v-row>
                    <v-row>
                        <!-- inv_lagername in DB -->
                        <BaseReadOnlyTextField 
                            :innerValue="getWarehouseName"
                            :label="$t('lang_AZ_GROUPS_CAPTION_WAREHOUSE_NAME')"
                            :alvqa="alvqa + '-warehouse-name'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getFocFirstShipment"
                            :label="$t('lang_AZ_GROUPS_CAPTION_FOC_FIRST_SHIPMENT')"
                            :alvqa="alvqa + '-foc-first-shipment'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getFocAllShipments"
                            :label="$t('lang_AZ_GROUPS_CAPTION_FOC_ALL_SHIPMENTS')"
                            :alvqa="alvqa + '-foc-all-shipments'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getHandlingFee"
                            :label="$t('lang_AZ_GROUPS_CAPTION_HANDLING_FEE')"
                            :alvqa="alvqa + '-handling-fee'"
                        />
                    </v-row>
                </v-col>

                <!-- 3rd column -->
                <v-col cols="5">
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getPublishingCompany"
                            :label="$t('lang_GENERIC_AZ_CAPTION_ASSIGN_TO_PUBLISHING_COMPANY')" 
                            :alvqa="alvqa + '-publishing-company'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getGemaMember"
                            :label="$t('lang_GENERIC_AZ_CAPTION_GEMA_MEMBER')"
                            :alvqa="alvqa + '-gema-member'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField 
                            :innerValue="getBgNineSplit"
                            :label="$t('lang_GENERIC_AZ_CAPTION_BG9_FOR_GEMA_MEMBER')"
                            :alvqa="alvqa + '-bg-nine-split'"
                        />
                    </v-row>
                </v-col>

            </v-row>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseReadOnlyTextField from '@/components/_readonly/BaseReadOnlyTextField'
import { DropdownGenericYesNo } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "MetadataPanel",
    components: {
        BasePanel,
        BaseReadOnlyTextField,
    },
    props:{
        azGroupsAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: "az-groups-readonly-panel-metadata"
        }
    },
    computed: {   
        item() {
            let item = this.$store.getters.getExpandedAzGroups.find(element => {
                return element.id === this.azGroupsAlvId
            })
            return item
        },  
        getLanguage() {
            let language = this.$store.getters.getAzGroupsMetadataDetailsLanguage
            return this.$alvPlugin.getTranslatedLanguageName(language)
        },
        getFoundingDate() {
            let date = this.$store.getters.getAzGroupsMetadataDetailsFoundingDate
            return date ? this.$d(new Date(date), 'alvDateFormat') : ''
        },
        getCustomerNumber() { return this.$store.getters.getAzGroupsMetadataDetailsCustomerNumber },
        getLabelCompany() { 
            let labelCompanyAlvId = this.$store.getters.getAzGroupsMetadataDetailsLabelCompany
            let companyName = ""
            let companyArr
            let companies = this.$store.getters.getLabelCompanies 
            if (companies !== undefined) {
                companyArr = JSON.parse(JSON.stringify(companies))
                companyArr.forEach(element => {
                    if (element['alvId'] === labelCompanyAlvId) companyName = element['name']
                });
            }
            return companyName
        },
        getLabelcode() { return this.$store.getters.getAzGroupsMetadataDetailsLabelcode },
        getTonisNextPrefix() { return this.$store.getters.getAzGroupsMetadataDetailsTonisNextPrefix },
        getTonisNextSuffix() { return this.$store.getters.getAzGroupsMetadataDetailsTonisNextSuffix },
        getTasFromPricelist() { 
            let value = this.$store.getters.getAzGroupsMetadataDetailsTasFromPricelist 
            let result = DropdownGenericYesNo.find(element => {
                return element.value === value
            }).text
            return this.$t(result)
        },
        getWarehouseName() { return this.$store.getters.getAzGroupsMetadataDetailsWarehouseName },
        getFocFirstShipment() { 
            let value = this.$store.getters.getAzGroupsMetadataDetailsFocFirstShipment 
            return (value != null ? value.toString() : '') 
        },
        getFocAllShipments() { 
            let value = this.$store.getters.getAzGroupsMetadataDetailsFocAllShipments 
            return (value != null ? value.toString() : '') 
        },
        getHandlingFee() { 
            let value = this.$store.getters.getAzGroupsMetadataDetailsHandlingFee 
            return (value != null ? value.toString() : '') 
        },
        getPublishingCompany() { 
            let publishingCompanyAlvId = this.$store.getters.getAzGroupsMetadataDetailsPublishingCompany
            let companyName = ""
            let companyArr
            let companies = this.$store.getters.getPublishingCompanies 
            if (companies !== undefined) {
                companyArr = JSON.parse(JSON.stringify(companies))
                companyArr.forEach(element => {
                    if (element['alvId'] === publishingCompanyAlvId) companyName = element['name']
                });
            }
            return companyName
        },
        getGemaMember() { 
            let value = this.$store.getters.getAzGroupsMetadataDetailsGemaMember 
            let result = DropdownGenericYesNo.find(element => {
                return element.value === value
            }).text
            return this.$t(result)
        },
        getBgNineSplit() { 
            let value = this.$store.getters.getAzGroupsMetadataDetailsBgNineSplit 
            let result = DropdownGenericYesNo.find(element => {
                return element.value === value
            }).text
            return this.$t(result)
        },
    },
    created() {
        this.$store.commit('setLanguages')
    }
}
</script>